import __request__ from "routing/request";
export function createNewKinesisStream(JSONbody, requestOptions) {
  return __request__("POST", "/aws/kinesis/auto_setup/create_stream", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createSubscription(JSONbody, requestOptions) {
  return __request__("POST", "/aws/kinesis/auto_setup/create_subscription", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function autoKinesisPermissions(JSONbody, requestOptions) {
  return __request__("POST", "/aws/kinesis/auto_setup/create_subscription_policy", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
